function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("mask", {
  id: "gateways_svg__a",
  maskUnits: "userSpaceOnUse",
  x: 0.891,
  y: 38.037,
  width: 374,
  height: 295,
  fill: "#000"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.891 38.037h374v295h-374z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M294.517 48.037c-12.15 0-22 9.85-22 22v48.191c0 12.15 9.85 22 22 22h48.071c12.15 0 22-9.85 22-22v-48.19c0-12.151-9.85-22-22-22h-48.071zM32.891 80.897c-12.15 0-22 9.85-22 22v113.911c0 12.15 9.85 22 22 22h113.705c12.15 0 22-9.85 22-22V102.897c0-12.15-9.85-22-22-22H32.891zm145.733 137.01c0-12.15 9.849-22 22-22h82.711c12.15 0 22 9.85 22 22v82.876c0 12.151-9.85 22.001-22 22.001h-82.711c-12.151 0-22-9.85-22-22v-82.877z"
}));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M282.517 70.037c0-6.627 5.373-12 12-12v-20c-17.673 0-32 14.327-32 32h20zm0 48.191v-48.19h-20v48.19h20zm12 12c-6.627 0-12-5.373-12-12h-20c0 17.673 14.327 32 32 32v-20zm48.071 0h-48.071v20h48.071v-20zm12-12c0 6.627-5.373 12-12 12v20c17.673 0 32-14.327 32-32h-20zm0-48.19v48.19h20v-48.19h-20zm-12-12c6.627 0 12 5.372 12 12h20c0-17.674-14.327-32-32-32v20zm-48.071 0h48.071v-20h-48.071v20zM20.891 102.896c0-6.627 5.373-12 12-12v-20c-17.673 0-32 14.327-32 32h20zm0 113.911V102.897h-20v113.911h20zm12 12c-6.627 0-12-5.372-12-12h-20c0 17.673 14.327 32 32 32v-20zm113.705 0H32.891v20h113.705v-20zm12-12c0 6.628-5.372 12-12 12v20c17.673 0 32-14.327 32-32h-20zm0-113.911v113.911h20V102.897h-20zm-12-12c6.628 0 12 5.373 12 12h20c0-17.673-14.327-32-32-32v20zm-113.705 0h113.705v-20H32.891v20zm167.733 95.01c-17.674 0-32 14.327-32 32h20c0-6.627 5.372-12 12-12v-20zm82.711 0h-82.711v20h82.711v-20zm32 32c0-17.673-14.327-32-32-32v20c6.627 0 12 5.373 12 12h20zm0 82.876v-82.876h-20v82.876h20zm-32 32.001c17.673 0 32-14.327 32-32.001h-20c0 6.628-5.373 12.001-12 12.001v20zm-82.711 0h82.711v-20h-82.711v20zm-32-32c0 17.673 14.327 32 32 32v-20c-6.628 0-12-5.373-12-12h-20zm0-82.877v82.877h20v-82.877h-20z",
  fill: "#000",
  mask: "url(#gateways_svg__a)"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 10.891,
  y: 80.897,
  width: 157.705,
  height: 157.911,
  rx: 22,
  fill: "#DAE2EB"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M116.671 163.057l-50.528 28.97c-2.722 1.627-6.129-.529-7.63-4.814a12.091 12.091 0 01-.65-3.128l-1.527-61.286c.114-4.582 3.419-8.214 7.325-8.113a5.94 5.94 0 012.601.676l53.133 32.314c2.459 1.814 2.838 6.697.948 10.906-.906 2.063-2.227 3.677-3.672 4.475z",
  fill: "#fff"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M116.013 169.425l.009-.005c1.019-.558 2.085-1.791 2.84-3.553l.004-.01h.001c.778-1.777 1.058-3.683.894-5.297-.165-1.619-.748-2.746-1.481-3.301l-50.3-30.41a4.225 4.225 0 00-1.81-.467l49.843 43.043zm0 0l-.01.005m.01-.005l-.01.005m0 0l-47.895 27.215-.01.005m47.905-27.22l-47.904 27.22m0 0l-.01.006m.01-.006l-.01.006m0 0c-.782.462-1.689.437-2.646-.164-.991-.623-1.989-1.858-2.62-3.657l-.001-.002m5.267 3.823l-5.267-3.823m0 0a9.957 9.957 0 01-.536-2.561m.536 2.561l-.536-2.561m0 0l-1.54-57.616c.09-3.754 2.722-6.346 5.423-6.274l-3.883 63.89z",
  fill: "#000",
  stroke: "#000",
  strokeWidth: 2.709
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M76.132 135.684c-4.694-2.664-10.546.693-10.546 6.054v39.878c0 5.361 5.852 8.72 10.546 6.056l35.137-19.941c4.724-2.679 4.724-9.427 0-12.107l-35.137-19.94z",
  fill: "#fff"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 178.624,
  y: 195.907,
  width: 126.711,
  height: 126.876,
  rx: 22,
  fill: "#fff"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 272.517,
  y: 48.037,
  width: 92.071,
  height: 92.191,
  rx: 22,
  fill: "#fff"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M272.517 257.519c0 16.132-13.06 29.209-29.17 29.209-16.111 0-29.171-13.077-29.171-29.209 0-16.132 13.06-24.645 29.171-24.645 16.11 0 29.17 8.513 29.17 24.645z",
  fill: "#000"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M271.017 249.891c0 15.305-12.39 27.709-27.67 27.709-15.281 0-27.671-12.404-27.671-27.709 0-7.614 3.06-13.337 7.97-17.192 4.951-3.887 11.89-5.953 19.701-5.953 7.81 0 14.749 2.066 19.7 5.953 4.91 3.855 7.97 9.578 7.97 17.192z",
  fill: "#DAE2EB",
  stroke: "#000",
  strokeWidth: 3
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M339.475 102.338c0-5.726-2.367-14.429-6.216-21.703-1.923-3.633-4.2-6.88-6.708-9.213-2.511-2.334-5.213-3.717-7.998-3.717-2.786 0-5.488 1.383-7.998 3.717-2.509 2.332-4.786 5.58-6.708 9.213-3.85 7.274-6.217 15.977-6.217 21.703 0 5.675 2.327 9.98 6.08 12.88 3.768 2.911 9.007 4.428 14.843 4.428 5.835 0 11.074-1.517 14.842-4.428 3.753-2.9 6.08-7.205 6.08-12.88z",
  fill: "#000",
  stroke: "#000"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M334.389 102.338c0-5.522-2.306-14.064-6.1-21.236-1.891-3.572-4.105-6.716-6.505-8.948-2.406-2.237-4.876-3.449-7.317-3.449-2.442 0-4.912 1.212-7.318 3.45-2.4 2.23-4.614 5.375-6.505 8.947-3.794 7.172-6.1 15.714-6.1 21.236 0 5.367 2.185 9.38 5.692 12.089 3.549 2.742 8.555 4.219 14.231 4.219 5.675 0 10.681-1.477 14.23-4.219 3.507-2.709 5.692-6.722 5.692-12.089z",
  fill: "#DAE2EB",
  stroke: "#000",
  strokeWidth: 3
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M85.461 83.05l-13.994-6.888H81.92l3.541 2.23v-2.94l6.716.71 9.751 4.747",
  fill: "#000"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M92.536 82.145l4.651 16.145 4.741-17.379h-7.25l-2.142 1.234z",
  fill: "#000"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M85.462 83.05l4.973-1.578 4.655.345-2.472 26.817-7.156-25.583z",
  fill: "#000"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M85.462 83.052l7.156 25.583-11.642-27.784 4.486 2.201z",
  fill: "#fff"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M76.37 78.58l5.794-.27 3.526 2.6v-3.947l6.177.735 9.564 5.033.497-1.822-9.751-4.747-6.716-.71v2.94l-3.541-2.23H71.467l4.904 2.419z",
  fill: "#DAE2EB"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M74.595 247.596l-9.992-3.904 53.371-2.44h39.724l15.11-10.493 2.193 51.001c-.974 10.493-3.119 31.283-3.899 30.502-.975-.976-1.972-29.316-4.409-34.44-2.437-5.125-1.949-19.733-5.605-23.637-2.925-3.124-61.879-5.694-86.493-6.589zM1.072 217.954l4.856 7.292c0-9.453.97-39.703 4.855-85.077 4.855-56.718 6.473-45.375 10.924-53.882 3.56-6.807 23.602-9.859 33.177-10.534h99.532l14.971 12.964 3.237 114.652 9.305-6.482c-9.305-7.292 1.375-67.467-1.457-71.924-2.832-4.456 1.862-23.281 1.457-30.169-.404-6.887-15.779-22.282-19.825-22.282h-57.858c-8.092 0-52.598-7.697-66.355-6.077-11.005 1.296-22.658 9.993-27.108 14.18L5.928 91.148l-4.856 21.067c-.809 3.241-1.942 10.857 0 15.395 1.942 4.537.81 62.12 0 90.344zM216.421 338.542c-12.832.306-28.261-8.286-34.372-12.62l35.567 2.166 75.949-4.555 14.515-9.083 2.674-76.1-6.875-39.771c3.438 6.246 10.388 19.273 10.694 21.415.382 2.677-1.146 29.446 2.291 43.595 3.438 14.149 3.056 48.566 0 54.302-3.055 5.736-51.94 13.767-62.251 12.62-10.312-1.147-22.151 7.648-38.192 8.031z",
  fill: "#000"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M292.179 317.264c-2.508 2.679-12.468 5.998-17.134 7.323l14.835 2.093 16.298-8.369 4.388-25.525c-1.463-2.581-4.388-7.281-4.388-5.44 0 2.301-3.552 7.532-3.552 16.11s-7.313 10.461-10.447 13.808zM77.003 233.152c-6.414-.494-33.592 5.064-46.379 7.905l34.29 1.852 37.128 1.729c11.965-2.223 32.786-6.521 20.352-5.928-15.541.741-37.374-4.94-45.391-5.558z",
  fill: "#000"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M364.574 96.831c-.363 4.115-1.338 12.039-9.308 27.113-2.347 4.438-8.839 7.664-16.822 10.028-13.712 4.06-31.82 5.577-40.869 6.325h44.999c12.15 0 22-9.85 22-22V96.831z",
  fill: "#DAE2EB"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M270.803 149.294h27.147l-18.764-9.395-9.382-10.736 1.563-78.061-7.818 13.42c-1.489 13.942-4.602 43.169-5.138 48.537-.67 6.71 7.383 19.459 7.83 26.84.447 7.382 1.211 9.395 4.562 9.395z",
  fill: "#000"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M338.381 151.754c-8.935 5.01-50.186.298-69.694-2.684l42.442-2.908 42.442-5.592c-1.34 1.641-6.254 6.174-15.19 11.184zM363.406 83.438c0 .974.892 5.682 1.338 7.915L369 66.39c-1.419-.488-4.256-.926-4.256 1.217 0 2.68-1.338 14.612-1.338 15.83z",
  fill: "#000"
});

var _ref23 = /*#__PURE__*/React.createElement("rect", {
  x: 175.734,
  y: 7.302,
  width: 67.458,
  height: 67.546,
  rx: 20,
  fill: "#000"
});

var _ref24 = /*#__PURE__*/React.createElement("rect", {
  x: 185.527,
  y: 2.5,
  width: 62.458,
  height: 62.546,
  rx: 17.5,
  fill: "#fff",
  stroke: "#000",
  strokeWidth: 5
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M193.182 82.788c-1.088-1.5-2.176-8.254-4.715-10.656-1.946-1.84-4.27-8.24-5.311-11.588l1.322-9.423 11.606 23.263 17.408-3.302 20.491-7.054 14.829-22.953 1.673 4.493c-.846 4.352-2.756 13.357-3.627 14.558-1.088 1.5-18.496 10.956-22.486 10.956-3.989 0-9.429 6.903-10.88 7.504-1.451.6-19.222 5.703-20.31 4.202z",
  fill: "#000"
});

var SvgGateways = function SvgGateways(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 339,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25);
};

export default __webpack_public_path__ + "static/gateways.a78437be.svg";
export { SvgGateways as ReactComponent };